module.exports = __webpack_public_path__ + "images/FUSA_icons/009-shirt.43bae703e75dea8760a4823637d82537.svg";